// React builder
import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InventoryIcon from '@mui/icons-material/Inventory';

// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";

// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";

// User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

// Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//ExpenseHead
import ExpenseHeadIndex from "./components/pages/ExpenseHead/Index";

//IncomeAndExpense
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";

//Item
import ItemIndex from "./components/pages/Item/Index";

//slab (room type)
import SlabIndex from "./components/pages/Slab/Index";

//Rooms
import RoomCreate from "./components/pages/Rooms/Create";
import RoomIndex from "./components/pages/Rooms/Index";
import RoomEdit from "./components/pages/Rooms/Edit";

// Company Logo
import CompanyLogo from '../src/components/pages/CompanyLogo/CompanyLogo.png';

//Home
import Home from "./components/pages/Home";

//RoomRegister
import RoomRegisterCreate from "./components/pages/RoomRegister/Create";
import RoomRegisterIndex from "./components/pages/RoomRegister/Index";
import RoomRegisterDetails from "./components/pages/RoomRegister/Details";
import ReceiptPrint from "./components/pages/RoomRegister/ReceiptPrint";

//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";


//Report
import RentCollection from "./components/pages/Report/RentCollection";
import CashBook from "./components/pages/Report/CashBook";
import CustomerRegister from "./components/pages/Report/CustomerRegister";
import Stock from "./components/pages/Report/Stock";

//Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//Logout
import Logout from "./Logout";

//SessionTimeOut
import SessionTimeout from "./SessionTimeout";

//App Icons
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import AddCardIcon from '@mui/icons-material/AddCard';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import SummarizeIcon from '@mui/icons-material/Summarize';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  //const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();
  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />

        <AppBar position="static" style={{ backgroundColor: '#B6CBBD', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            {/* <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography variant="h6" className="dual-text" component="div" style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative' }}>
                    <span style={{ color: '#FF5733' }}>{companyName.slice(0, 1)}</span>
                    <span style={{ color: '#C70039' }}>{companyName.slice(1, 2)}</span>
                    <span style={{ color: '#900C3F' }}>{companyName.slice(2)}</span>
                  </Typography>

                </Link>
              </div>
              <Typography component="div" style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative', color: '#4C4B16', fontFamily: 'monospace', fontSize: '14px' }}>
                👤{username}
              </Typography>
              <div className="white-icon" style={{ marginTop: '-5px' }}>
                <Logout />
              </div>
            </Typography> */}


            <Typography
              variant="h6"
              component="div"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              {/* Left Section */}
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link
                  to="/Home"
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography
                    variant="h6"
                    className="dual-text"
                    component="div"
                    style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative' }}
                  >
                    <span style={{ color: '#FF5733' }}>{companyName.slice(0, 1)}</span>
                    <span style={{ color: '#C70039' }}>{companyName.slice(1, 2)}</span>
                    <span style={{ color: '#900C3F' }}>{companyName.slice(2)}</span>
                  </Typography>
                </Link>
              </div>

              {/* Right Section */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography
                  component="div"
                  style={{
                    fontWeight: 'bolder',
                    color: '#4C4B16',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                  }}
                >
                  👤 {username}
                </Typography>
                <div className="white-icon" style={{ marginTop: '5px' }}>
                  <Logout />
                </div>
              </div>
            </Typography>

          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>

            <Typography variant="h5" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', position: 'relative' }}>
              <span style={{ color: '#FF5733' }}>{companyName.slice(0, 1)}</span>
              <span style={{ color: '#C70039' }}>{companyName.slice(1, 2)}</span>
              <span style={{ color: '#900C3F' }}>{companyName.slice(2)}</span>
            </Typography>

          </div>
          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <ListItemText primary="HOME" style={{ color: 'black' }} />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/BranchIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <StoreIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="Branch" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <CategoryIcon style={{ color: '#3C3D37', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/SlabIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <MeetingRoomIcon style={{ color: '#808D7C', height: '20px' }} /><ListItemText primary="Room Type" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/RoomIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <MeetingRoomIcon style={{ color: '#808D7C', height: '20px' }} /><ListItemText primary="Room " style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AddCardIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="ExpenseHead" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
              </List>
            </Collapse>

            <ListItem button onClick={handleItemClick}>
              <ListItemText primary="TRANSACTION" />
              {itemOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
               
                <ListItem button component={NavLink} to="/RoomRegisterIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <MeetingRoomIcon style={{ color: '#808D7C', height: '20px' }} /><ListItemText primary="Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <InventoryIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px', color: 'black'  }} />
                </ListItem>

              </List>
            </Collapse>
            <ListItem button onClick={handleOtherClick}>
              <ListItemText primary="ACCOUNTS" />
              {otherOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={otherOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/IncomeExpenseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AddCardIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="Income Expense" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            <ListItem button onClick={handleReportClick}>
              <ListItemText primary="REPORT" />
              {reportOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>


            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
              </List>

              <ListItem button component={NavLink} to="/RentCollection" activeClassName="selected" onClick={handleDrawerClose}>
                <AddCardIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="Rent Collection" style={{ marginLeft: '3px', color: 'black' }} />
              </ListItem>

              <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose}>
                <CurrencyRupeeIcon style={{ color: 'blue#9B3922violet', height: '20px' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px', color: 'black' }} />
              </ListItem>

              <ListItem button component={NavLink} to="/CustomerRegister" activeClassName="selected" onClick={handleDrawerClose}>
                <AddCardIcon style={{ color: '#795757', height: '20px' }} /><ListItemText primary="Customer Register" style={{ marginLeft: '3px', color: 'black' }} />
              </ListItem>

              <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose}>
                <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Stock" style={{ marginLeft: '3px', color: 'black' }} />
              </ListItem>

            </Collapse>

            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER" />
              {userOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                  </ListItem>
                )}

                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                  </ListItem>
                )}

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                </ListItem>
              </List>
            </Collapse>
          </List>
        </Drawer>

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />

            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />

            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />

            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />

            {/* Item  */}
            <Route path="/ItemIndex" component={ItemIndex} />

            {/* Room Type Slab  */}
            <Route path="/SlabIndex" component={SlabIndex} />

            {/* Room  */}
            <Route path="/RoomCreate" component={RoomCreate} />
            <Route path="/RoomIndex" component={RoomIndex} />
            <Route path="/RoomEdit/:id" component={RoomEdit} />
            {/*ExpenseHead*/}
            <Route path="/ExpenseIndex" component={ExpenseHeadIndex} />
            {/*IncomeAndExpense*/}
            <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
            <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
            <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
            <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />
            {/* Logout */}

            {/* Room Register  */}
            <Route path="/RoomRegisterCreate/:id" component={RoomRegisterCreate} />
            <Route path="/RoomRegisterIndex" component={RoomRegisterIndex} />
            <Route path="/RoomRegisterDetails/:id" component={RoomRegisterDetails} />
            <Route path="/ReceiptPrint/:id" component={ReceiptPrint} />
          
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />

            {/* Report */}
            <Route path="/RentCollection" component={RentCollection} />
            <Route path="/CashBook" component={CashBook} />
            <Route path="/CustomerRegister" component={CustomerRegister} />
            <Route path="/Stock" component={Stock} />
            
          </Switch>
        </Container>
      </AuthProvider>
    </Router>
  );
};

export default App;

